import React, {useEffect, useState} from 'react';
import {
    Button,
    CardText,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import {Controller, useForm} from "react-hook-form";
import axios from "axios";
import toast from "react-hot-toast";

const EditSociety = ({isOpen, handleClose, item}) => {

    const [loading, setLoading] = useState(false);
    const defaultValues = {
        taxId: '',
        name: ''
    }
    
    const {
        control,
        setError,
        handleSubmit,
        setValue,
        reset,
        formState: { errors }
    } = useForm({ defaultValues });

    useEffect(() => {
        if (item) {
            setValue('taxId', item.taxId);
            setValue('name', item.name);
        } else {
            reset();
        }
    }, [item])

    const onSubmit = async (data) => {
        if (Object.values(data).every(field => field.length > 0)) {
            try {
                setLoading(true);
                await axios.post(`${process.env.REACT_APP_API_URL}/companies/${item.id}`, {
                    name: data.name,
                    taxId: data.taxId
                });
                setLoading(false);
                toast.success('Sociedad actualizada con exito!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (e) {
                setLoading(false);
                toast.error(`Ha ocurrido un error: ${e.message}`);
            }
        } else {
            for (const key in data) {
                if (data[key].length === 0) {
                    setError(key, {
                        type: 'manual'
                    })
                }
            }
        }
    }
    
    return (
        <Modal isOpen={isOpen} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Editar sociedad</h1>
                    <p>Editar sociedad con los datos correspondientes.</p>
                </div>

                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Actualizando sociedad...</CardText>
                    </div>
                </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='name'>
                            Nombre*
                        </Label>
                        <Controller
                            control={control}
                            name='name'
                            render={({ field }) => {
                                return (
                                    <Input
                                        {...field}
                                        taxId='name'
                                        placeholder='Sociedad Inc.'
                                        value={field.value}
                                        invalid={errors.name && true}
                                    />
                                )
                            }}
                        />
                        {errors.name && <FormFeedback>Por favor ingrese un nombre de sociedad valido</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='taxId'>
                            ID Tributario*
                        </Label>
                        <Controller
                            id='taxId'
                            name='taxId'
                            control={control}
                            render={({field}) => <Input placeholder='ID tributario'
                                                        invalid={errors.taxId && true} {...field} />}
                        />
                        {errors.taxId && <FormFeedback>El id tributario es obligatorio</FormFeedback>}
                    </Col>

                    <Col md={12} xs={12}>
                        <small className={'text-secondary'}>
                            Campos obligatorios (*)
                        </small>
                    </Col>

                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='submit' className='me-1' color='primary'>
                            Guardar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleClose(false)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}
            </ModalBody>
        </Modal>
    );
};

export default EditSociety;

